import { useSelector } from 'react-redux';

export const useCustomSegments = ({levelsPropertyName = 'level'} = {}) => {
  const { customSegments } = useSelector(state => state.accounting);

  return customSegments.filter(s => s?.setup?.active && (s?.setup?.[levelsPropertyName]?.length > 0))
};
